<template>
  <div class="special-offer">
    <pageHeader title="无限0.1折" />

    <div class="game-container">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="暂无更多数据"
        @load="onLoad"
      >
        <div class="game-list">
          <img
            class="plat-bg"
            v-if="gameList.length"
            :src="pageImgUrl"
            alt=""
            @click="topGameJump()"
          />
          <div
            :class="['game-item']"
            v-for="info in gameList"
            :key="info.id"
          >
            <div class="game-item-content" @click="jumpDetail(info)">
              <img class="game-logo" :src="info.logoUrl" alt="" />
              <div class="game-info">
                <div class="game-info-title">
                  <h1>{{ info.gameName }}</h1>
                  <span>{{ info.discount }}</span>
                </div>
                <div class="game-info-desc">
                  <div class="game-info-gift">
                    <span v-if="info.wealf">福利</span>
                    <span v-if="!info.wealf && info.havaGift == 1">礼包</span>
                    <span v-if="info.isBTgame">变态特权</span>
                    <span v-if="info.waterMark == 1">专属折扣</span>
                    <span
                      v-if="
                        info.havaGift == 0 &&
                        !info.isBTgame &&
                        !info.wealf &&
                        info.waterMark == 0
                      "
                      >{{ info.title }}</span
                    >
                  </div>
                  <div class="star" v-if="info.starInfo">
                    <img
                      :key="star"
                      v-for="star in info.starInfo.allStar"
                      src="@/assets/images/star_all.png"
                      alt=""
                    />
                    <img
                      :key="star+999"
                      v-for="star in info.starInfo.halfStar"
                      src="@/assets/images/star_half.png"
                      alt=""
                    />
                  </div>
                </div>
                <div class="game-tag">
                  <span
                    v-for="tag in info.formatGameType"
                    :key="tag"
                    >{{ tag }}</span
                  >
                  <span class="other-tag">{{ info.openServerDate }}</span>
                </div>
              </div>
            </div>
            <operateBtns :gameInfo="info" @doOperate="doOperate" />
            <!-- <div class="game-item-operate">
              <span @click="doOperate(info, 'recharge')">充值</span>
              <span @click="doOperate(info, 'download')">下载</span>
            </div> -->
          </div>
        </div>
      </van-list>
    </div>

    <gamePlatPopup
      v-if="gamePlatPopupVisible"
      v-model="gamePlatPopupVisible"
      :btnType="btnType"
      :gameInfo="gameInfo"
    ></gamePlatPopup>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import gamePlatPopup from "@/components/GamePlatPopup.vue";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
import operateBtns from "@/components/OperateBtns.vue"
export default {
  components: {
    pageHeader,
    gamePlatPopup,
    operateBtns
  },
  data() {
    return {
      gameList: [],
      loading: false,
      finished: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      location: "PUBLIC_PARISE",
      btnType: '',
      gameInfo: {},
      pageImgUrl: '',
      topGameInfo: {},
      gamePlatPopupVisible: false
    };
  },
  computed: {
    ...mapGetters(["uuid", "isLogin"]),
  },
  methods: {
    resetList() {
      this.currentPage = 1; // 重置页码为第一页
      this.finished = false; // 重置 finished 状态
      this.gameList = []; // 清空当前列表
      this.totalCount = 0;
    },

    async onLoad() {
      this.loading = true;
      const { data, totalCount } = await this.gameListQr();

      this.gameList = [...this.gameList, ...data];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize);
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },

    /**
     * 根据分类查询游戏列表
     */
    async gameListQr() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/web/game/queryGameByTypeOrTheme.htm",
          "post",
          {
            code: "GAME_TYPE",
            value: "GM_NEW_GAME",
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          }
        );
        if (this.currentPage == 1) {
          if (data.length) {
            this.gameVideoImgQr(data);
          }
        }
        let list = this.gameInit(data)
        return {
          data: list,
          totalCount: totalCount,
        };
      } catch (error) {
        this.toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    /**
     * 遍历查询游戏的videoImgUrl
     */
    async gameVideoImgQr(data) {
      for (let i = 0; i < data.length; i++) {
        let info = data[i];
        const { videoImgUrl } = await this.gameDetailInfo(info.id);
        if (videoImgUrl) {
          this.pageImgUrl = videoImgUrl;
          break;
        } else {
          this.pageImgUrl = videoImgUrl;
        }
      }
    },

    /**
     * 查询第一个游戏的游戏详情
     */
    async gameDetailInfo(id) {
      try {
        const { data } = await requestMethods(
          "/modules/web/game/gameDetail.htm",
          "post",
          {
            gameId: id,
            uuid: this.uuid,
            appType: "WM",
          }
        );
        this.topGameInfo = data
        return data;
      } catch (error) {
        this.$toast(error.message);
      }
    },

    doOperate(scope, chennel) {
      // if(!this.isLogin) {
      //   this.$router.push('/login')
      //   return
      // }
      this.btnType = chennel == "recharge" ? "00" : "01";
      this.gameInfo = {
        gameName: scope.gameName,
        gameId: scope.id
      }
      this.gamePlatPopupVisible = true;
    },

    jumpDetail(info) {
      this.$router.push({ path: '/detail', query: {
        gameId: info.id
      } })
    },

    topGameJump() {
      this.$router.push({
        path: "/detail",
        query: {
          gameId: this.topGameInfo.gameId
        },
      });
    },

    gameInit(list) {
        this.setGameTag(list);
        this.setGameStar(list);
        return list;
      },
      /**
       * 处理游戏标签和开服信息显示
       */
      setGameTag(list) {
        list.forEach((g) => {
          let formatGameType = [];
          if (g.typeNamesList && g.typeNamesList.length) {
            let isBTgame = g.typeNamesList.includes("BT游戏");
            let hasKouBeiBangTag = g.typeNamesList.includes("口碑榜");
            let hasTeJiaTag = g.typeNamesList.includes("特价");
            g.isBTgame = isBTgame;
            if (hasKouBeiBangTag && hasTeJiaTag) {
              formatGameType.push("口碑榜");
              formatGameType.push("特价");
            } else if (!hasKouBeiBangTag && !hasTeJiaTag) {
              formatGameType.push(...g.typeNamesList.slice(0, 2));
            } else if (hasKouBeiBangTag || hasTeJiaTag) {
              if (hasKouBeiBangTag) {
                formatGameType.push("口碑榜");
              }
              if (hasTeJiaTag) {
                formatGameType.push("特价");
              }
              if (g.typeNamesList.length > 0) {
                let filterArr = g.typeNamesList.filter(
                  (e) => e != "口碑榜" && e != "特价"
                );
                formatGameType.push(filterArr[0]);
              }
            }
          }
          g.formatGameType = formatGameType;
        });
        return list;
      },
  
      /**
       * 处理游戏星标
       */
      setGameStar(list) {
        list.forEach((k) => {
          let level = Number(k.gamehotlevel);
          if (level == 0) {
            //不设置
          } else if (level == 1) {
            k.starInfo = { allStar: 0, halfStar: 1 };
          } else if (level == 2) {
            k.starInfo = { allStar: 1, halfStar: 0 };
          } else if (level == 3) {
            k.starInfo = { allStar: 1, halfStar: 1 };
          } else if (level == 4) {
            k.starInfo = { allStar: 2, halfStar: 0 };
          } else if (level == 5) {
            k.starInfo = { allStar: 2, halfStar: 1 };
          } else {
            k.starInfo = { allStar: 3, halfStar: 0 };
          }
        });
        return list;
      },
  },
};
</script>

<style lang="scss" scoped>
.special-offer {
  .game-container {
    .game-list {
      padding: 20px 15px;

      .plat-bg {
        width: 690px;
        height: 343px;
        margin: 0 15px;
        border-radius: 16px;
      }
    }
    .game-item {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 20px;
      padding: 20px 15px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .game-item-bg {
      background: #fff3e7;
    }

    .game-item-content {
      display: flex;
      align-items: center;

      .game-logo {
        width: 132px;
        height: 132px;
        margin-right: 20px;
      }
      .game-info {
        .game-info-title {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          h1 {
            max-width: 300px;
            font-weight: 600;
            font-size: 32px;
            color: #000000;
            line-height: 45px;
            margin-right: 6px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          span {
            display: block;
            padding: 5px 5px;
            font-weight: 600;
            font-size: 22px;
            color: #ffffff;
            height: 30px;
            background: #ff7a3e;
            border-radius: 4px;
          }
        }
        .game-info-desc {
          width: 379px;
          display: flex;
          align-items: center;
          margin-bottom: 20px;

          .game-info-gift {
            span {
              padding: 4px 12px;
              background: #f8f8f8;
              border-radius: 4px;
              border: 1px solid #f8f8f8;
              font-weight: 500;
              font-size: 18px;
              color: #a2a2a2;
              margin-right: 8px;
            }
          }
          .star {
            display: flex;
            align-items: center;
            img {
              width: 24px;
              margin-right: 8px;
            }
          }
        }
        .game-tag {
          span {
            padding: 2px 6px;
            // background: #f8f8f8;
            border-radius: 22px;
            border: 0px solid #d2d2d2;
            font-weight: 600;
            font-size: 20px;
            color: #a2a2a2;
            // margin-right: 18px;
          }
          .other-tag {
            color: #ffbe70;
          }
        }
      }
    }

    .game-item-operate {
      span {
        display: block;
        width: 105px;
        height: 50px;
        border-radius: 25px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 28px;
        line-height: 50px;
        text-align: center;

        &:first-child {
          color: #ffffff;
          background: #ff7a3e;
          margin-bottom: 23px;
        }
        &:last-child {
          border: 2px solid #ff7a3e;
          color: #ff7a3e;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/oneOff/index.vue